import React from 'react';
import { remove } from 'react-querybuilder';
import { useAtomValue } from 'jotai';
import {
  FilterRulesBuilder,
  type QueryBuilderFieldSchema,
  type Query,
} from '@components/filter/components/common/FilterRulesBuilder';
import { FilterRuleTags } from '@components/filter/components/common/FilterRuleTags';
import { useDrilldownLimit } from 'components/filter/components/Management/hooks';
import { disabledOperators } from '@src/components/filter/components/utils';
import * as atoms from '../../../atom';
import * as Styled from './styled';

interface Props {
  query: Query;
  showError?: boolean;
  defaultField?: QueryBuilderFieldSchema;
  fields: QueryBuilderFieldSchema[];
  onChange: (query: Query) => void;
}

const FilterRules = (props: Props) => {
  const { query, fields = [], defaultField, showError, onChange } = props;
  const filterMeta = useAtomValue(atoms.filterMeta);
  const dataSource = useAtomValue(atoms.dataSource);
  const drilldownLimit = useDrilldownLimit(dataSource);

  const handleOnDelete = (path: number[]) => {
    const newQuery = remove(query, path);
    onChange(newQuery);
  };

  return (
    <Styled.Container className="filter-rules-container">
      <FilterRuleTags filterMeta={filterMeta} query={query} onDelete={handleOnDelete} />
      <Styled.BuilderContainer>
        <FilterRulesBuilder
          dataSource={dataSource}
          showError={showError}
          initialField={defaultField}
          fields={fields}
          query={query}
          drilldownLimit={drilldownLimit}
          disabledOperators={disabledOperators}
          onChange={onChange}
        />
      </Styled.BuilderContainer>
    </Styled.Container>
  );
};

export default React.memo(FilterRules);
